import { createThemeCompiler } from '../../../utils';

export const carouselThemeCompiler = createThemeCompiler(({ borderRadius, palette, stroke }) => ({
    carousel: {
        colors: {
            dotsNavigationBorderColor: palette.black,
            dotsNavigationPanelBackgroundColor: palette.white,
            dotsNavigationBackgroundColor: palette.white,
            dotsNavigationBackgroundColorOnActive: palette.black,
            arrowNavigationColor: palette.white,
            arrowNavigationColorOnHover: '#0e9bff9c'
        },
        composites: {
            dotsNavigationBorderRadius: borderRadius.circle,
            dotsNavigationBorderWidth: stroke.thin
        }
    }
}));
